import type { ISEOProps } from "../types/core";

export const PacksPageSEO: ISEOProps = {
  title: "Credit Packages | Sugar Cribs",
  description:
    "Buy credit packages on Sugar Cribs. Choose from Flirt Pack, Passion Pack, Obsession Pack, VIP Lover Pack, Luxury Pack, and Elite Pack with exclusive discounts.",
};
